import { Checkbox } from 'antd';
import cn from 'classnames';
import React from 'react';

import { ChildFilter } from '@/types/filters/filters.types';

import styles from './option.module.scss';

export const Option: React.FC<{
  selectOption: () => void;
  option: ChildFilter;
}> = ({ option, selectOption }) => {
  return (
    <>
      {typeof option.vehicleCount !== 'number' || option.vehicleCount ? (
        <div
          className={cn(styles.option, {
            [styles.optionSelected as string]: option.isChecked,
          })}
          onClick={selectOption}
        >
          <Checkbox checked={option.isChecked} className={styles.optionInput} />
          <span>{option.name}</span>
          {option.vehicleCount && (
            <span className={styles.optionAmount}>({option.vehicleCount})</span>
          )}
        </div>
      ) : null}
    </>
  );
};
